import Handlebars from "handlebars";

Handlebars.registerHelper("stripPTags", function (string) {
  if (string == undefined) {
    return;
  } // when we are adding a new collection item

  if (string.indexOf("<p>") !== -1) {
    string = string.replace(/<br>/g, "");
    string = string.replace(/<\/p><p>/g, "<br>");
    string = string.replace(/<p>|<\/p>/g, "");
  }

  return string;
});
